import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class NavBarMenuItem extends Component {
  static propTypes = {
    idName: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    onItemClick: PropTypes.func,
    typeId: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  _onClick = () => {
    const { onItemClick, typeId } = this.props;
    onItemClick.call(null, typeId);
  };

  render = () => {
    const { idName, className, title, children } = this.props;
    return (
      <a
        id={idName}
        className={className}
        data-test={this.props.dataTest}
        onClick={this._onClick}
      >
        {title}
        {children}
      </a>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/ui/NavBarMenuItem.js